import * as yup from "yup";
import { getValidationSchema } from "../../../../../shared/validations/schema";
export const customizeValidationSchema = () => {

  let defaultSchema: any = getValidationSchema([
    "name",
  ]);
  
  let customSchema = yup.object().shape({
    //add custom validation here
    name: yup
    .string()
    .trim("Job Type cannot include leading and trailing spaces")
    .strict(true)
    .min(2, "Job Type must be more than 2 characters")
    .max(100, "Job Type cannot exceed more than 100 characters")
    .matches(
      /^[a-zA-Z0-9].*[a-zA-Z0-9]$/,
      "Job Type cannot start or end with a special character"
    )
    .matches(
      /^[a-zA-Z0-9 .&/-]+$/,
      "Job Type can only contain letters, numbers, spaces, periods, &, hyphens, and slashes"
    )
    .required("Job Type is required"),
    
  });

  return defaultSchema.concat(customSchema);
};

